
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import ScenariosHero from './components/ScenariosHero';
import ScenarioCardsSection from './components/ScenarioCardsSection';
import DeliverablesSection from './components/DeliverablesSection';
import ScenarioBottomCTA from './components/ScenarioBottomCTA';
import { useState } from 'react';

export default function ScenariosPage() {
  const [filters, setFilters] = useState({ industry: '', mode: '', goal: '' });

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <ScenariosHero />
      <ScenarioCardsSection onFiltersChange={setFilters} />
      <DeliverablesSection />
      <ScenarioBottomCTA
        selectedIndustry={filters.industry}
        selectedMode={filters.mode}
        selectedGoal={filters.goal}
      />
      <Footer />
    </div>
  );
}
